/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CustomerBundleTypeConfigValueContract} from '../../api/contracts/bundle-config/customer-bundle-type-config-value.contract';
import {CustomerBundleTypeConfigValueModel} from '../../models/bundle-config/customer-bundle-type-config-value.model';

export class CustomerBundleTypeConfigValueMapper {
    static fromCustomerBundleTypeConfigValueContractArray(input: CustomerBundleTypeConfigValueContract[]):
            CustomerBundleTypeConfigValueModel[] {
        return input?.map((element) => CustomerBundleTypeConfigValueMapper.fromCustomerBundleTypeConfigValueContract(element));
    }

    static fromCustomerBundleTypeConfigValueContract(input: CustomerBundleTypeConfigValueContract): CustomerBundleTypeConfigValueModel {
        let customerBundleTypeConfigValueModel: CustomerBundleTypeConfigValueModel;
        if (input != null) {
            customerBundleTypeConfigValueModel = {
                key: input.key,
                value: input.value
            };
        }
        return customerBundleTypeConfigValueModel;
    }
}
